import { menuItemClasses, menuPanelClasses } from "@/design-system/Menu/Menu";
import { cn } from "@/lib/utils";
import { t } from "@repo/shared/i18n";
import { JSX } from "react";

import { plusIcon } from "../../../../../designSystemIcons";
import {
  chemistryIcon,
  evolve,
  filter as filterIcon,
  roleIcon,
} from "../../../../../icons";

// Items without a handler are left out
type Props = {
  onClickInsert?: () => void;
  onClickRole?: () => void;
  onClickChemstyle?: () => void;
  onClickEvolve?: () => void;
  onClickFilters?: () => void;
  numberOfFilters?: number;
  cantChangeChemstyle?: boolean;
};
export const PlayerSidePanel = ({
  onClickInsert,
  onClickRole,
  onClickChemstyle,
  onClickEvolve,
  onClickFilters,
  numberOfFilters,
  cantChangeChemstyle,
}: Props) => {
  return (
    <div className={cn(menuPanelClasses, "flex flex-col w-28")}>
      {onClickInsert && (
        <PanelItem
          icon={plusIcon}
          value={t("squadBuilder:mobile.insert")}
          onClick={onClickInsert}
        />
      )}
      {onClickRole && (
        <PanelItem
          icon={roleIcon}
          value={t("squadBuilder:mobile.role")}
          onClick={onClickRole}
        />
      )}
      {onClickChemstyle && (
        <PanelItem
          icon={chemistryIcon}
          value={t("squadBuilder:mobile.chemstyle")}
          onClick={onClickChemstyle}
          disabled={cantChangeChemstyle}
        />
      )}
      {onClickEvolve && (
        <PanelItem
          icon={evolve}
          value={t("squadBuilder:mobile.evolve")}
          onClick={onClickEvolve}
          // disabled={!canEvolve}
        />
      )}
      {onClickFilters && (
        <PanelItem
          icon={filterIcon}
          value={t("common:filters")}
          onClick={onClickFilters}
          count={numberOfFilters}
        />
      )}
    </div>
  );
};

const PanelItem = ({
  icon,
  value,
  onClick,
  disabled,
  count,
}: {
  icon: React.JSX.Element;
  value: string;
  onClick: () => void;
  disabled?: boolean;
  count?: number;
}) => {
  return (
    <button
      // Compact rows to fit beside the card
      className={cn(
        menuItemClasses({ disabled }),
        "gap-x-2 px-2 py-1.5 text-xs font-medium",
      )}
      onClick={(e) => {
        if (!disabled) {
          onClick();
        }
        e.stopPropagation();
      }}
    >
      <div className="size-5 shrink-0">{icon}</div>
      {value}
      {/* Same pill as the filter button's count */}
      {count > 0 && (
        <span className="ml-auto w-5 h-5 shrink-0 text-sm font-bold text-center text-white rounded-full bg-primary-blue">
          {count}
        </span>
      )}
    </button>
  );
};
